import { jwtDecode } from "jwt-decode";

// Shared wording for requests sent from Help (backend help/feature_requests.py).
export const KIND_LABELS = {
  not_on: "Switched off for the clinic",
  role: "Not available for their role",
  not_available: "Not in MindConnect yet",
  other: "Help didn't answer it",
};

export const STATUS_LABELS = {
  new: "New",
  reviewing: "Being looked at",
  forwarded: "With MindConnect",
  closed: "Closed",
};

export const PLATFORM_STATUS_LABELS = {
  new: "Received",
  planned: "Planned",
  switched_on: "Switched on",
  done: "Available now",
  declined: "Not planned",
};

export const STATUS_TONES = {
  new: "bg-amber-100 text-amber-800",
  reviewing: "bg-sky-100 text-sky-800",
  forwarded: "bg-primary-100 text-primary-800",
  closed: "bg-secondary-100 text-secondary-700",
  planned: "bg-sky-100 text-sky-800",
  switched_on: "bg-emerald-100 text-emerald-800",
  done: "bg-emerald-100 text-emerald-800",
  declined: "bg-secondary-100 text-secondary-700",
};

export function currentRole() {
  try {
    const auth = JSON.parse(localStorage.getItem("auth") || "{}");
    const role = auth.token ? jwtDecode(auth.token).sub?.role : auth.role;
    return (role || "").toLowerCase();
  } catch {
    return "";
  }
}

export const formatDate = (iso) =>
  iso ? new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" }) : "";
